import { useEffect, useRef } from 'react';

import { useDispatch } from 'react-redux';

import { trackProductListFilter } from '~/shared/actions';

import useGridInputs from './useGridInputs';

const useFacetTracking = ({
  selectedUrlFilters: facets,
  selectedSortOption: sortOption,
}) => {
  const dispatch = useDispatch();
  const prevfacetsRef = useRef({});
  const prevSort = useRef('');
  const { productSource } = useGridInputs();

  useEffect(() => {
    const previous = prevfacetsRef.current;
    const appliedFacets = [];
    const clearedFacets = [];
    const facetKeys =
      facets && Object.keys(facets).length > 0 ? facets : previous;

    Object.keys(facetKeys).forEach((facetKey) => {
      const previousFacetValues = previous[facetKey] || [];
      const currentFacetValues = facets[facetKey] || [];

      const applied = currentFacetValues.filter(
        (item) => !previousFacetValues.includes(item)
      );
      if (applied.length) {
        appliedFacets.push(
          ...applied.map((facetValue) => ({
            label: 'Apply',
            filter: { type: facetKey, value: facetValue },
          }))
        );
      }

      const cleared = previousFacetValues.filter(
        (item) => !currentFacetValues.includes(item)
      );
      if (cleared.length) {
        clearedFacets.push(
          ...cleared.map((facetValue) => ({
            label: 'Clear',
            filter: { type: facetKey, value: facetValue },
          }))
        );
      }
    });

    const filterList = Object.values({ ...appliedFacets, ...clearedFacets });

    filterList.forEach((filterInfo) => {
      dispatch(
        trackProductListFilter({
          label: filterInfo.label,
          filters: filterInfo.filter,
          list_id: productSource,
          sort: [{ field: sortOption }],
        })
      );
    });

    prevfacetsRef.current = facets;
  }, [dispatch, facets, sortOption, productSource]);

  const isSortDifferent = prevSort.current && prevSort.current !== sortOption;

  if (isSortDifferent) {
    dispatch(
      trackProductListFilter({
        list_id: productSource,
        sort: [{ field: sortOption }],
      })
    );
  }

  prevSort.current = sortOption;

  return null;
};

export default useFacetTracking;
